import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Mic, FileText } from "lucide-react";

export default function ModeToggle() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";
  const mode = isHomePage ? "voice" : "write";

  const handleModeToggle = () => {
    if (isHomePage) {
      navigate("/app");
    } else {
      navigate("/");
    }
  };

  return (
    <button
      onClick={handleModeToggle}
      className="group relative inline-flex items-center gap-3 bg-zinc-800/80 hover:bg-zinc-700/80 text-white px-5 py-2.5 rounded-full transition-all duration-300 border border-zinc-700/50 hover:border-zinc-600/50 backdrop-blur-md shadow-lg shadow-black/30"
      data-testid="mode-toggle"
    >
      {/* Icons */}
      <div className="relative flex items-center justify-center w-5 h-5">
        {mode === "voice" ? (
          <Mic size={18} className="text-signal-info" />
        ) : (
          <FileText size={18} className="text-brand" />
        )}
      </div>
      
      {/* Text */}
      <span className="relative text-sm font-medium tracking-wide">
        {mode === "voice" ? "Switch to Write" : "Switch to Voice"}
      </span>
      
      {/* Active indicator */}
      <div 
        className={`w-2 h-2 rounded-full transition-colors duration-300 ${
          mode === "voice" ? "bg-signal-info" : "bg-brand"
        }`}
      />
      
      {/* Mode description tooltip */}
      <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none transform translate-y-2 group-hover:translate-y-0">
        <div className="bg-black/90 backdrop-blur-xl text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap border border-white/10 shadow-xl">
          {mode === "voice" ? "Switch to Write" : "Switch to Voice"}
        </div>
      </div>
    </button>
  );
}
